export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10226.74c6b56c.jpg";